import Vue from 'vue'

export const colaborativeBoard = {
    namespaced: true,
    state: {
        fileId: null,
        page: null,
        pageSize: { width: 0, height: 0 },
        surveyId: null
    },
    actions: {
        setFileId({ commit }, { fileId, page }) {
            commit('setFileId', { fileId, page });
        },
        setPage({ commit }, { page }) {
            commit('setPage', { page });
        },
        setPageSize({ commit }, { width, height }) {
            commit('setPageSize', { width, height });
        },
        closeDocument({ commit }) {
            commit('closeDocument');
        },
        setSurveyId({ commit }, { surveyId }) {
            commit('setSurveyId', { surveyId });
        },
        closeSurvey({ commit }) {
            commit('closeSurvey');
        }
    },
    mutations: {
        setFileId(state, { fileId, page }) {
            Vue.set(state, 'fileId', fileId);
            Vue.set(state, 'page', page);
        },
        setPage(state, { page }) {
            Vue.set(state, 'page', page);
        },
        setPageSize(state, { width, height }) {
            Vue.set(state.pageSize, 'width', width);
            Vue.set(state.pageSize, 'height', height);
        },
        closeDocument(state) {
            Vue.set(state, 'fileId', null);
        },
        setSurveyId(state, { surveyId }) {
            Vue.set(state, 'surveyId', surveyId);
        },
        closeSurvey(state) {
            Vue.set(state, 'surveyId', null);
        }
    },
    getters: {
        getFileId: state => state.fileId,
        getPage: state => state.page,
        getPageSize: state => state.pageSize,
        getSurveyId: state => state.surveyId
    }
}